export default "__VITE_ASSET__2f99a739__"